import { Form } from '@entities/leadCollector';
import { gql, useQuery } from 'urql';
import { useCallback } from 'react';

const FORMS_QUERY = gql`
  query GetForms {
    getForms {
      id
      name
      status
      createdAt
    }
  }
`;

export interface FormsResponse {
  getForms: Form[];
}

export const useFetchForms = (pause = false) => {
  const [{ data, fetching, error }, executeQuery] = useQuery<FormsResponse>({
    query: FORMS_QUERY,
    pause,
    requestPolicy: 'network-only',
  });

  const forms = data?.getForms;

  const refetch = useCallback(() => {
    executeQuery({ requestPolicy: 'network-only' });
  }, [executeQuery]);

  return {
    fetching,
    error,
    forms,
    refetch,
  };
};
